import { Box } from '@factorialco/deprecated-design-system'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import InputText from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

import type { BookingRequestForm, CallRequestForm } from './forms'
import validateNumberInput from './forms'

export const CallForm = ({
  form,
  numberPlaceHolder,
}: {
  form: CallRequestForm
  numberPlaceHolder: string
}) => {
  return (
    <Box padding="s24" background="grey100" gap="s12">
      <InputText
        label={i18n.t('pricing_plans.help_info.callpage_modal.phone_number')}
        field={form.get('phone')}
        placeholder={numberPlaceHolder}
        validation={validateNumberInput}
        mandatory
      />
    </Box>
  )
}

export const BookingForm = ({
  form,
  numberPlaceHolder,
}: {
  form: BookingRequestForm
  numberPlaceHolder: string
}) => {
  return (
    <Box padding="s24" background="grey100" gap="s12">
      <InputText
        label={i18n.t('pricing_plans.help_info.callpage_modal.phone_number')}
        field={form.get('phone')}
        placeholder={numberPlaceHolder}
        validation={validateNumberInput}
        mandatory
      />
      <DayPicker
        label={i18n.t('pricing_plans.help_info.callpage_modal.date')}
        field={form.get('date')}
        mandatory
      />
      <InputText
        type="time"
        label={i18n.t('pricing_plans.help_info.callpage_modal.hour')}
        field={form.get('time')}
        mandatory
      />
    </Box>
  )
}
